import { dateFormats, DateObject, useIntl, useLogger } from '@capsicum/common';

export const useFeedDates = () => {
	const { $t } = useIntl();
	const logger = useLogger();

	const { diff, format } = dateFormats;

	const timeSince = (publishTime: DateObject, currentTime: DateObject = new DateObject()) => {
		const diffInDays = diff(currentTime, publishTime, 'days', true);

		if (diffInDays <= 0) {
			logger.warn("Expected Error, the current date can't be preceding the feed date");

			return 'unknown';
		}

		return diffInDays >= 1 ? format(publishTime, 'L') : parsedtimeSince(publishTime, currentTime);
	};

	const timeFormatted = (time: DateObject, dateFormat: string) => {
		return format(time, dateFormat);
	};

	//TODO Date formats should be the ones used by dayjs library/common chiliz standard?
	const parsedtimeSince = (publishTime: DateObject, currentTime: DateObject = new DateObject()) => {
		const diffInSeconds = diff(currentTime, publishTime, 'seconds');
		const diffInMinutes = diff(currentTime, publishTime, 'minutes');
		const diffInHours = diff(currentTime, publishTime, 'hours');

		if (diffInSeconds < 60) return $t('feed.publishTime.seconds', { seconds: diffInSeconds });
		if (diffInMinutes < 60) return $t('feed.publishTime.minutes', { minutes: diffInMinutes });

		return $t('feed.publishTime.hours', { hours: diffInHours });
	};

	return {
		timeFormatted,
		timeSince
	};
};
